interface Params {
  value: number;
  decimalPlaces: number;
  roundingDirection?: "floor" | "ceil" | "round";
}

export function customRound(params: Params): number {
  const { value, decimalPlaces, roundingDirection = "floor" } = params;

  if (!Number.isFinite(value)) {
    return value;
  }

  const multiplier = 10 ** decimalPlaces;

  switch (roundingDirection) {
    case "floor":
      return Math.floor(value * multiplier) / multiplier;
    case "ceil":
      return Math.ceil(value * multiplier) / multiplier;
    case "round":
      return Math.round(value * multiplier) / multiplier;
    default:
      return value;
  }
}
